import { Routes, Route } from "react-router-dom";
import WorklistPage from "./WorklistPage";

export default function WorklistRoutes() {
  return (
    <Routes>
      <Route index element={<WorklistPage />} />
    </Routes>
  );
}
